import { API_BASE_URL } from "./api-base-url";

function appendQueryParams(url, queryParams) {
  Object.keys(queryParams || {}).forEach((key) => {
    const value = queryParams[key];
    if (Array.isArray(value)) {
      value.forEach((item) => url.searchParams.append(key, item));
      return;
    }
    if (value !== null && value !== undefined) {
      url.searchParams.append(key, value);
    }
  });
}

export function buildApiUrl(address, queryParams) {
  if (!API_BASE_URL) {
    throw new Error("API base URL is not configured (REACT_APP_API_BASE_URL in development)");
  }

  const url = new URL(`${API_BASE_URL}/api/${address}`);
  appendQueryParams(url, queryParams);
  return url;
}

export async function serverFetch(address, options = {}, signal) {
  const url = buildApiUrl(address, options.queryParams);

  const headers = new Headers({
    Accept: "application/json",
    "Content-Type": "application/json"
  });

  const sessionId = localStorage.getItem("sessionId");
  if (sessionId) {
    headers.append("sessionId", sessionId);
  }

  if (options.headers) {
    Object.keys(options.headers).forEach((key) => headers.append(key, options.headers[key]));
  }

  const init = {
    method: options.method || "GET",
    credentials: "include",
    headers,
    signal
  };

  if (options.bodyData !== undefined) {
    init.body = JSON.stringify(options.bodyData);
  }

  const response = await fetch(url, init);
  if (response.status === 204) {
    return null;
  }

  const isJson = response.headers.get("content-type")?.includes("application/json");
  const content = isJson ? await response.json() : await response.text();

  if (!response.ok) {
    const message =
      typeof content === "string"
        ? content
        : content?.userMessage || content?.message || "Request failed";
    throw new Error(message);
  }

  return content;
}
